import { render, staticRenderFns } from "./rating.vue?vue&type=template&id=42d8f269"
import script from "./rating.vue?vue&type=script&lang=ts"
export * from "./rating.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports